// eslint-disable-next-line no-restricted-syntax
enum BuyingGuideSectionTypes {
  ImageSection = 1,
  GenericContent = 2,
  TableSection = 3,
  TableHeaderSection = 4,
  RelatedResources = 5,
  TextImageLeft = 6,
  TextImageRight = 7,
  DoubleImage = 8,
  TripleImage = 9,
  FullImage = 10,
  Video = 11,
  SectionGrouping = 12,
  TableGrouping = 13,
  QuadrupleImage = 14,
  ProConList = 15,
}

export default BuyingGuideSectionTypes;
